import React, {Component} from 'react';
import ReactTable from "react-table";
import 'react-table/react-table.css'
import DashboardStatistics from "../../containers/dashboard_container";
import Loader from "../universal/loader";


class ClerkDashBoard extends Component {

    constructor(props) {
        super(props);
        this.state = {
            new:false
        }
    }


    componentDidMount(){
      this.props.getClerkDashboardData(this.props.startDate,this.props.endDate)
    }

    render() {
        const columns = [{
            Header: 'Name',
            accessor: 'name',
            filterable: true,
            className:"left-aligned"
        }, {
            Header: 'Assigned Properties',
            accessor: 'assigned_properties',
            filterable: true
        }, {
            Header: 'Scheduled',
            accessor: 'scheduled',
            filterable: true
        }, {
            Header: 'Confirmed',
            accessor: 'confirmed',
            filterable: true
        }, {
            Header: 'Processing',
            accessor: 'processing',
            filterable: true
        }, {
            Header: 'Abort',
            accessor: 'aborted',
            filterable: true
        }, {
            Header: 'Submitted',
            accessor: 'submitted',
            filterable: true
        }, {
            Header: 'Completed',
            accessor: 'completed',
            filterable: true
        }];

        return (<div style={{width: '100%', margin: 'auto'}} className="center-aligned">
            {!this.props.isClerkDashBoardFetching && this.props.clerkDashboardData.length > 0 && <ReactTable
                data={this.props.clerkDashboardData}
                columns={columns}
                defaultFilterMethod={(filter, row, column) => {
                    const id = filter.pivotId || filter.id;
                    return row[id] !== undefined ? String(row[id]).toUpperCase().startsWith(filter.value.toUpperCase()) : true
                }}
                defaultPageSize={5}
                minRows={0}
                noDataText="No Clerks Available"
            /> }
            {this.props.isClerkDashBoardFetching && <Loader contain={true} customText="Loading Clerk Dashboard" />}
            <div style={{minHeight: '50px'}}></div>
        </div>)
    }
}

export default DashboardStatistics(ClerkDashBoard);


// WEBPACK FOOTER //
// ./src/views/dashboard/clerk_dashboard.js